exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-4f18f5f8] {\n  color: #f56c6c;\n  font-size: 0.072917rem;\n}\n.form-wrapper[data-v-4f18f5f8] {\n  display: flex;\n  align-items: center;\n}\n.form-wrapper[data-v-4f18f5f8]:first-child {\n  margin-bottom: 0.104167rem;\n}\n.form-wrapper .form-label[data-v-4f18f5f8] {\n  min-width: 0.625rem;\n}", ""]);

// exports
